export class VehicleStatusCalculator {
  static getInventoryType(vehicle?: any): string | undefined {
    return vehicle?.salesInfo?.availableFromDateInfo?.value;
  }

  static isAvailableNow(vehicle?: any): boolean {
    return this.getInventoryType(vehicle) === 'Immediately';
  }

  static getVehicleStatus(vehicle?: any): string | undefined {
    if (!vehicle) return undefined;

    const isAvailable = vehicle.cartypeText === 'U' && this.isAvailableNow(vehicle);
    if (isAvailable) return 'available';

    return vehicle.salesInfo?.orderStatusText || 'Unavailable';
  }

  static getSaleType(vehicle?: any): string | undefined {
    if (!vehicle) return undefined;

    const isAvailable = vehicle.cartypeText === 'U' && this.isAvailableNow(vehicle);
    if (isAvailable) return 'available-now';

    return vehicle.salesInfo?.saleOrderTypeText || this.getInventoryType(vehicle);
  }

  static getSaleOrderType(vehicle?: any): string | null {
    if (!vehicle || this.isAvailableNow(vehicle)) return null;
    return vehicle.salesInfo?.saleOrderTypeText ?? null;
  }

  static getOrderStatus(vehicle?: any): string | null {
    if (!vehicle || this.isAvailableNow(vehicle)) return null;
    return vehicle.salesInfo?.orderStatusText ?? null;
  }
}
